export * from './node/index';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
